import { Flex } from 'components'
import { createContext, useContext, useState } from 'react'
import { EventBanner, EventInfoTabs, EventManage, EventSetupState } from '../components/event'
import QrMappingDrawer from '../components/event/EventManage/QrMappingDrawer'
import { useEvent } from '../utils/eventUtils'

interface IEventInfoContext {
  /** false - panel close, true - panel open, number - panel open with specific moment */
  moments: number | boolean
  showManage: boolean
  showFieldMapping: boolean
  shrinkBanner: boolean
  updateShowManage: (manage: boolean) => void
  updateShowFieldMapping: (fieldMapping: boolean) => void
  updateMoments: (moments: number | boolean) => void
  updateShrinkBanner: (shrinkBanner: boolean) => void
}

const EventInfoContext = createContext<IEventInfoContext>({} as any)

export const useEventInfo = () => useContext(EventInfoContext)

export default function EventInfoPage() {
  const { deleteEvent, event, updateEvent } = useEvent()
  const qrCode = event?.qrCode
  const [showManage, setShowManage] = useState(false)
  const [showFieldMapping, setShowFieldMapping] = useState(false)
  const [moments, setMoments] = useState<number | boolean>(false)
  const [shrinkBanner, setShrinkBanner] = useState(false)

  if (!event) return null

  return (
    <EventInfoContext.Provider
      value={{
        moments,
        showFieldMapping,
        showManage,
        shrinkBanner,
        updateMoments: setMoments,
        updateShowFieldMapping: setShowFieldMapping,
        updateShowManage: setShowManage,
        updateShrinkBanner: setShrinkBanner,
      }}
    >
      <Flex
        overflow="auto"
        direction="column"
        pt={{ base: 0, md: 3 }}
        pb={3}
        pr={{ base: 0, md: 5 }}
        gap={2}
      >
        {!shrinkBanner && <EventBanner />}
        {event.sessionCount > 0 ? <EventInfoTabs /> : <EventSetupState />}
      </Flex>
      <EventManage
        event={event}
        open={showManage}
        onClose={async body => {
          setShowManage(false)
          if (!body) return

          updateEvent({ ...body, id: event.id })
        }}
        onDelete={deleteEvent}
        refetchImage={() => updateEvent(event)}
      />

      {qrCode && !showManage && (
        <QrMappingDrawer qrCode={qrCode} onUpdate={qrCode => updateEvent({ qrCode })} />
      )}
    </EventInfoContext.Provider>
  )
}
